import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import PageHeader from "../components/PageHeader";
import LoadingState from "../components/LoadingState";
import EmptyState from "../components/EmptyState";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function NotificationsPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all");
    const navigate = useNavigate();

    const load = async () => {
        setLoading(true);
        try {
            const params = { limit: 200 };
            if (filter === "unread") params.is_read = false;
            else if (filter !== "all") params.kind = filter;
            const { data } = await api.get("/notifications", { params });
            setItems(data.items || []);
        } catch { toast.error("Errore caricamento"); }
        finally { setLoading(false); }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

    const readOne = async (n) => {
        try {
            await api.post(`/notifications/${n.id}/read`);
            load();
        } catch { /* */ }
        if (n.url && n.url.startsWith("/") && !n.url.startsWith("/api/")) navigate(n.url);
    };

    const readAll = async () => {
        try { await api.post("/notifications/read-all"); toast.success("Tutte segnate come lette"); load(); }
        catch { toast.error("Errore"); }
    };

    return (
        <div className="space-y-4">
            <PageHeader
                title="Notifiche"
                subtitle="Centro notifiche personale"
                breadcrumbs={[{ label: "Notifiche" }]}
                actions={<button data-testid="notif-read-all" onClick={readAll}
                    className="text-xs px-3 py-1.5 rounded-md border border-[#DCE3EE] bg-white">Segna tutte come lette</button>}
            />
            <div className="flex gap-2 text-xs">
                {[
                    ["all", "Tutte"], ["unread", "Non lette"], ["alert", "Alert"],
                    ["assignment", "Assegnazioni"], ["report_ready", "Report"], ["escalation", "Escalation"]
                ].map(([k, l]) => (
                    <button key={k} data-testid={`notif-filter-${k}`} onClick={() => setFilter(k)}
                        className={`px-3 py-1.5 rounded-md ${filter === k ? "bg-[#0B1633] text-white" : "bg-white border border-[#DCE3EE]"}`}>{l}</button>
                ))}
            </div>
            {loading ? <LoadingState /> : items.length === 0 ? <EmptyState title="Nessuna notifica" /> : (
                <div className="bg-white border border-[#DCE3EE] rounded-xl divide-y divide-[#DCE3EE]" data-testid="notifications-list">
                    {items.map((n) => (
                        <div key={n.id} onClick={() => readOne(n)}
                            data-testid={`notif-row-${n.id}`}
                            className={`px-4 py-3 cursor-pointer hover:bg-[#F5F7FB] ${n.is_read ? "opacity-60" : ""}`}>
                            <div className="text-[11px] uppercase text-[#64748B]">{n.kind}</div>
                            <div className="text-sm font-medium text-[#172033]">{n.title}</div>
                            {n.body && <div className="text-xs text-[#64748B]">{n.body}</div>}
                            <div className="text-[11px] text-[#94A3B8] mt-0.5">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
